import styled from 'styled-components';
import { palette } from 'styled-tools';

import pauseIcon from 'icons/pause-fill-sf.svg';
import playIcon from 'icons/play-fill-sf.svg';

export const Button = styled.button`
	align-items: center;
	background: ${palette('white')};
	border: 0;
	border-radius: 999px;
	color: ${palette('black')};
	cursor: pointer;
	display: flex;
	font-size: 16px;
	font-weight: 500;
	gap: 8px;
	line-height: 19.8px;
	justify-content: center;
	padding: 15px 20px;
	width: 100%;
`;

// SF Symbol play.fill / pause.fill at 16pt medium, the size iOS gives the glyph in this button.
export const PlayGlyph = styled(playIcon)`
	flex-shrink: 0;
	height: 13px;
	width: 12.5px;

	& path {
		fill: ${palette('black')};
		stroke: ${palette('black')};
	}
`;

export const PauseGlyph = styled(pauseIcon)`
	flex-shrink: 0;
	height: 13.2px;
	width: 9.8px;

	& path {
		fill: ${palette('black')};
	}
`;
